import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { toRgbString } from 'packages/kakapo-ui-kit/helpers/HexColor';

const Container = styled(Box)<{
	occupied: boolean;
}>`
	position: relative;
	background: rgba(
		${(props) => toRgbString(props.occupied ? props.theme.colors.red : props.theme.colors.yellow)},
		0.9
	);
	color: white;
`;

export default function LearningEventOccupancyWarning(props: { count: number; total: number }) {
	const { t } = useTranslation();

	return (
		<Container p={3} occupied={props.count >= props.total}>
			{props.count >= props.total
				? t('learning.event.modal.occupancyWarning.occupied', {
						count: props.count,
						total: props.total,
				  })
				: t('learning.event.modal.occupancyWarning.almostReached', {
						count: props.count,
						total: props.total,
				  })}
		</Container>
	);
}
